<template>
  <v-card class="transparent elevation-0 text-center d-flex flex-column">
    <img class="elevation-0 rounded-lg m-auto" :src="imageSrc" />
    <v-card-actions class="transparent">
      <v-btn color="transparent mx-auto" depressed fab @click="$emit('input', false)">
        <v-icon x-large class="transparent grey--text text--lighten-2">mdi-close</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    imageSrc: { type: String, required: true }
  }
}
</script>

<style></style>
